var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 84,
    viewBox: "0 0 106 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 84C6.275 84 4.4375 83.2125 2.8625 81.6375C1.2875 80.0625 0.5 78.225 0.5 76.125V7.875C0.5 5.775 1.2875 3.9375 2.8625 2.3625C4.4375 0.787499 6.275 0 8.375 0H97.625C99.725 0 101.562 0.787499 103.137 2.3625C104.712 3.9375 105.5 5.775 105.5 7.875V76.125C105.5 78.225 104.712 80.0625 103.137 81.6375C101.562 83.2125 99.725 84 97.625 84H8.375ZM53 44.3625L8.375 15.0938V76.125H97.625V15.0938L53 44.3625ZM53 36.4875L97.1 7.875H9.03125L53 36.4875ZM8.375 15.0938V7.875V76.125V15.0938Z",
    fill: "url(#paint0_linear_17831_20)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17831_20",
    x1: -27.5307,
    y1: 13.2893,
    x2: 4.6705,
    y2: 109.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#FEC809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#FF9022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAuth);
export default __webpack_public_path__ + "static/media/mail_auth.bf349c523a044f8f432f55d48cc64b07.svg";
export { ForwardRef as ReactComponent };